import { styled } from 'styled-components';

export const SectionContainer = styled('div')({
    padding: '20px 0',
});
